import React from "react";
import {
  Container,
  Paper,
  Typography,
  Button,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import ContentWrapper from "../../../common/components/contentWrapper";
import "../../pages/dashboard/style/style.css";
import "../../../common/style/main.css";
import { MfaOverallSetting } from "../reducer/actions";

const MFAPage = () => {
  const history = useHistory();

  const handleSetupNow = () => {
    history.push("/mfa-verification");
  };

  const getUserId = () => {
    const userDetails = sessionStorage.getItem('userDetails')
      ? JSON.parse(sessionStorage.getItem('userDetails'))
      : null;

    return (
      userDetails?.userid ||
      userDetails?.user?.userid ||
      userDetails?.userId
    );
  };

const handleRemindLater = () => {
    const userid = getUserId();

    const payload = {
      userid: userid,
      userId: userid,
      is_remindme_later: true,
      remindme_date: new Date(),
      mfa_enabled_status: "remindmelater",
      mfa_channel: null
    };
    const TempToken = sessionStorage.getItem("temp_token");
    if(TempToken) {
      sessionStorage.setItem("token", TempToken);
      sessionStorage.removeItem("temp_token");
    }

    MfaOverallSetting(payload, (err, res) => {
      if (res?.status === 1) {
        console.log("Remind later saved");
        history.push("/search"); 
      } else {
        console.log("Error saving remind later");
      }
    });
  };

  const handleNoThanks = () => {
    const userid = getUserId();

    const payload = {
      userid: userid,
      userId: userid,
      is_remindme_later: false,
      remindme_date: null,
      mfa_enabled_status: "notNow",
      mfa_channel: null
    };
    const TempToken = sessionStorage.getItem("temp_token");
    if(TempToken) {
      sessionStorage.setItem("token", TempToken);
      sessionStorage.removeItem("temp_token");
    }
    MfaOverallSetting(payload, (err, res) => {
      if (res?.status === 1) {
        console.log("User skipped MFA");
        history.push("/search");
      } else {
        console.log("Error saving no thanks");
      }
    });
  };

  const contentView = (
    <div>
      <Container
        maxWidth="sm"
        style={{
          minHeight: "80vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper className="border-radius">

          <div
            style={{
              background: "#383838",
              marginBottom: "15px",
              padding: "10px",
            }}
          >
            <Typography
              variant="h5"
              align="center"
              className="text-white"
            >
              Secure Your Account
            </Typography>
          </div>

          <p
            style={{
              color: "#555",
              fontSize: "15px",
              textAlign: "center",
              padding: "0 20px",
            }}
          >
            Enable Multi-Factor Authentication (MFA) to protect your account.
          </p>

          <div style={{ padding: "0 20px", marginTop: "20px" }}>

            <div style={{ display: "flex", gap: "10px", marginBottom: "15px" }}>
              <div
                style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  background: "rgba(202,171,116,0.15)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "5px",
                }}
              >
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    background: "#CAAB74",
                  }}
                />
              </div>

              <div>
                <b>Email OTP</b>
                <p style={{ color: "#666", fontSize: "14px" }}>
                  Receive verification codes via email
                </p>
              </div>
            </div>

            <div style={{ display: "flex", gap: "10px" }}>
              <div
                style={{
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  background: "rgba(202,171,116,0.15)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: "5px",
                }}
              >
                <div
                  style={{
                    width: "8px",
                    height: "8px",
                    borderRadius: "50%",
                    background: "#CAAB74",
                  }}
                />
              </div>

              <div>
                <b>SMS OTP</b>
                <p style={{ color: "#666", fontSize: "14px" }}>
                  Receive verification codes via phone
                </p>
              </div>
            </div>

          </div>

          <div style={{ padding: "20px" }}>

            <Button
              variant="contained"
              fullWidth
              onClick={handleSetupNow}
              style={{
                backgroundColor: "#CAAB74",
                color: "#fff",
                marginBottom: "10px",
              }}
            >
              Set Up Now
            </Button>

            <Button
              variant="outlined"
              fullWidth
              onClick={handleRemindLater}
              style={{
                borderColor: "#CAAB74",
                color: "#CAAB74",
                marginBottom: "10px",
              }}
            >
              Remind Me Later
            </Button>

            <Button
              fullWidth
              onClick={handleNoThanks}
              style={{ color: "#777" }}
            >
              No Thanks
            </Button>

          </div>
        </Paper>
      </Container>
    </div>
  );

  return <ContentWrapper contentView={contentView} />;
};

export default MFAPage;